import { useState } from 'react'
import { motion } from 'framer-motion'

// Import all images
import lotteryAppImage from '../assets/lottery-app.png'
import myReadsImage from '../assets/myreads.jpg'
import youtubeImage from '../assets/youtube.jpg'
import todoImage from '../assets/todo.jpg'
import hikingImage from '../assets/hiking.png'
import restaurantSearcherImage from '../assets/restaurant-searcher.jpg'
import notesAppImage from '../assets/notes-app.jpg'
import searchPhotosImage from '../assets/search-photos.png'
import pizzaImage from '../assets/pizza.jpg'
import thriveAppImage from '../assets/thriveapp.png'
import thriveSiteImage from '../assets/thrivesite.png'
import vismeImage from '../assets/visme.jpg'
import abImage from '../assets/ab.png'
import evaluoImage from '../assets/img-evaluo.jpg'
import trmImage from '../assets/trm.jpg'
import politometriImage from '../assets/img-politometri.jpg'
import docAssistImage from '../assets/doc-assist.png'

// Import videos
import restaurantVideo from '../assets/restaurant.mp4'
import notesVideo from '../assets/notes.mp4'
import vismeVideo from '../assets/visme.mp4'

const Projects = () => {
  const [activeTab, setActiveTab] = useState('personal')

  const personalProjects = [
    {
      title: 'AI Document Assistant (DocAssist)',
      technologies: 'React | TypeScript | OpenAI API',
      description:
        'Upload contracts and policies, generate AI-powered summaries, extract structured fields, and verify results before they flow into downstream systems. Analysis runs server-side using the OpenAI API, with a focused, human-in-the-loop document review workflow.',
      github: null,
      live: 'https://ai-document-assistant7.netlify.app/',
      image: docAssistImage,
      type: 'web'
    },
    {
      title: 'Lottery App',
      technologies: 'React Js | Web3.js | Solidity',
      description: 'The lottery project includes the smart contract written in Solidity, and the lottery-react project is a React application that interacts with the smart contract. The Lottery smart contract allows participants to enter the lottery by sending a minimum amount of Ether. The manager can pick a random winner.',
      github: 'https://github.com/shejza/lottery-app',
      live: null,
      image: lotteryAppImage,
      type: 'web'
    },
    {
      title: 'My Reads',
      technologies: 'React Js | Redux | HTML/SCSS',
      description: 'In the MyReads project, you\'ll create a bookshelf app that allows you to select and categorize books you have read, are currently reading, or want to read. The project emphasizes using React to build the application and provides an API server and client library that you will use to persist information as you interact with the application.',
      github: 'https://github.com/shejza/my-reads',
      live: 'https://my-reads-application-in-react.herokuapp.com',
      image: myReadsImage,
      type: 'web'
    },
    {
      title: 'Mini YouTube',
      technologies: 'React Js',
      description: 'This is a mini youtube project, to have access to youtube videos I have used API of youtube. The focus for this project was on React Js, how to get data from API and how to use them.',
      github: 'https://github.com/shejza/mini-youtube',
      live: null,
      image: youtubeImage,
      type: 'web'
    },
    {
      title: 'Take Notes',
      technologies: 'React Js, Laravel',
      description: 'A full-stack note-taking application with user authentication. Features include creating notes with multiple descriptions, marking individual or all notes as finished, and user registration/login. Built with React/Redux frontend and Laravel backend.',
      github: 'https://github.com/shejza/take-notes',
      live: null,
      image: todoImage,
      type: 'web'
    },
    {
      title: 'Hiking',
      technologies: 'HTML/SCSS',
      description: 'This project is about my hiking adventures, and my stories. On this project I have used HTML, and SCSS, I also used BEM methodology to write more clean code. The site is fully responsive.',
      github: 'https://github.com/shejza/hiking.github.io',
      live: 'https://shejza.github.io/hiking.github.io/',
      image: hikingImage,
      type: 'web'
    },
    {
      title: 'Restaurant Searcher',
      technologies: 'React Native',
      description: 'A mobile app for discovering restaurants and searching for specific foods. Integrates with Yelp API to provide real-time restaurant data, reviews, and menu information. Built with React Native for cross-platform mobile development.',
      github: null,
      live: null,
      image: restaurantSearcherImage,
      video: restaurantVideo,
      type: 'mobile'
    },
    {
      title: 'Notes',
      technologies: 'React Native',
      description: 'A mobile note-taking app with collection-based organization. Users can create collections to group related notes, add new notes within collections, and edit existing content. Built with React Native for cross-platform mobile development.',
      github: null,
      live: null,
      image: notesAppImage,
      video: notesVideo,
      type: 'mobile'
    },
    {
      title: 'Search Photos',
      technologies: 'React Js',
      description: 'A dynamic photo search application that integrates with Unsplash API. Users can search for high-quality images by keywords, with real-time results and responsive design. Built with React for modern web development.',
      github: 'https://github.com/shejza/pic-search-app',
      live: 'https://shejza.github.io/pic-search-app/',
      image: searchPhotosImage,
      type: 'web'
    },
    {
      title: 'The Yummi Pizza',
      technologies: 'React Js, Laravel',
      description: 'A web application for ordering pizzas online with a menu of 8 pizzas and shopping cart functionality. Built with React/Redux frontend and Laravel backend, deployed on Heroku.',
      github: 'https://github.com/shejza/pizza-react',
      live: null,
      image: pizzaImage,
      type: 'web'
    }
  ]

  const companyProjects = [
    {
      title: 'Thrive App',
      company: 'Thrive Protocol',
      description: 'Main platform for contribution tracking and rewards that automates treasury allocations to builders who create real value. Features builder profile creation for funding opportunities, application tracking, and growing crypto\'s GDP through value-based allocations.',
      technologies: ['React.js', 'TypeScript', 'Web3.js', 'TailwindCSS', 'React Query', 'Storybook', 'Cypress'],
      image: thriveAppImage,
      live: 'https://app.thrive.xyz/',
      type: 'web'
    },
    {
      title: 'ThriveCoin Website',
      company: 'ThriveCoin',
      description: 'Core company website representing ThriveCoin\'s activities and services. As a Frontend Developer, created a pixel-perfect, responsive website using HTML, SCSS, React.js and the latest web standards.',
      technologies: ['React.js', 'TypeScript', 'HTML/SCSS', 'Easy Peasy', 'Git'],
      image: thriveSiteImage,
      type: 'web'
    },
    {
      title: 'Community Apps',
      company: 'Thrive Protocol',
      description: 'Developed and maintained individual dynamic apps for partner ecosystems including Hedera, Polygon, APE, Boba, Metis, Xion, Swell, Blife, Portals, and more. Each community app is customized for specific blockchain ecosystems while maintaining core Thrive functionality.',
      technologies: ['React.js', 'TypeScript', 'Web3.js', 'TailwindCSS', 'React Query', 'Storybook'],
      image: null,
      initials: 'CA',
      type: 'web'
    },
    {
      title: 'Admin Interface',
      company: 'Thrive Protocol',
      description: 'Tools for internal review workflows and platform management. Built comprehensive admin dashboard for managing platform operations, user reviews, and internal processes.',
      technologies: ['React.js', 'TypeScript', 'TailwindCSS', 'React Query', 'Storybook'],
      image: null,
      initials: 'AI',
      type: 'web'
    },
    {
      title: 'Contributor Profiles',
      company: 'Thrive Protocol',
      description: 'Public dashboards for contributors to view their impact, badges, and activity. Built comprehensive profile system showcasing contributor achievements, metrics, and community engagement.',
      technologies: ['React.js', 'TypeScript', 'TailwindCSS', 'React Query', 'Storybook'],
      image: null,
      initials: 'CP',
      type: 'web'
    },
    {
      title: 'VISME',
      company: 'Visme',
      description: 'Contributed to product improvements and innovation of new functionalities as a Frontend developer using React.js, TypeScript and the latest web standards. Coordinated with team members to continually refine and enhance user-requested features.',
      technologies: ['React.js', 'TypeScript', 'HTML/SCSS', 'MobX', 'Git'],
      image: vismeImage,
      video: vismeVideo,
      type: 'web'
    },
    {
      title: 'A/B Testing',
      company: 'Sogody',
      description: 'Split-run testing platform comparing two variants (A and B) to determine which is more effective. Manipulated and rearranged existing client website code using JavaScript, built fast and error-free tests for clients including Samsung across different countries.',
      technologies: ['JavaScript', 'TypeScript', 'HTML/SCSS', 'jQuery', 'CSS'],
      image: abImage,
      type: 'web'
    },
    {
      title: 'Evaluo',
      company: 'Smart Bits GmbH',
      description: 'An online testing platform with multiple question types, user participation, results tracking, and analytics. Worked as a full-stack developer creating comprehensive test management features and data visualization tools.',
      technologies: ['Laravel', 'Bootstrap', 'PHP', 'MySQL'],
      image: evaluoImage,
      type: 'web'
    },
    {
      title: 'Training Management System',
      company: 'Smart Bits GmbH',
      description: 'A web application that offers companies a seamless and fully-featured training process for their employees. Created the complete front-end from scratch using HTML/SCSS with React and Redux for state management.',
      technologies: ['HTML/SCSS', 'React', 'Redux'],
      image: trmImage,
      type: 'web'
    },
    {
      title: 'Politometri',
      company: 'Smart Bits GmbH',
      description: 'A web application designed to help users find which political party programs in Kosovo match their expectations and demands of the government. Created the complete front-end from scratch using HTML and SCSS.',
      technologies: ['HTML/SCSS'],
      image: politometriImage,
      type: 'web'
    }
  ]

  return (
    <div className="min-h-screen pt-16">
      {/* Hero Section */}
      <section className="section-padding">
        <div className="max-w-6xl mx-auto px-2">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6">
              What I've been up to.
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Here are some highlights of my recent work.
            </p>
          </motion.div>

          {/* Tabs */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex justify-center mb-12"
          >
            <div className="flex bg-gray-100 dark:bg-custom-800 rounded-lg p-1 w-full max-w-md mx-auto">
              <button
                onClick={() => setActiveTab('personal')}
                className={`flex-1 px-3 sm:px-6 py-2 rounded-md font-medium transition-all duration-200 text-sm sm:text-base ${
                  activeTab === 'personal'
                    ? 'bg-white dark:bg-custom-700 text-gray-900 dark:text-white shadow-sm'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                }`}
              >
                Personal
              </button>
              <button
                onClick={() => setActiveTab('company')}
                className={`flex-1 px-3 sm:px-6 py-2 rounded-md font-medium transition-all duration-200 text-sm sm:text-base ${
                  activeTab === 'company'
                    ? 'bg-white dark:bg-custom-700 text-gray-900 dark:text-white shadow-sm'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                }`}
              >
                Company
              </button>
            </div>
          </motion.div>

          {/* Personal Projects */}
          {activeTab === 'personal' && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="space-y-8"
            >
              {personalProjects.map((project, index) => (
                <motion.div
                  key={project.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex flex-col md:flex-row gap-4 md:gap-6 relative min-h-[300px] md:h-48"
                >
                  <div className="absolute inset-0 border border-gray-300/20 dark:border-gray-600/20 pointer-events-none"></div>
                  
                  {/* Badge */}
                  <div className="absolute top-3 right-3 z-10">
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                      project.type === 'mobile' 
                        ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-400'
                        : 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400'
                    }`}>
                      {project.type === 'mobile' ? 'Mobile' : 'Web'}
                    </span>
                  </div>
                  
                  {/* Project Image/Video */}
                  <div className="w-full md:w-64 h-48 md:h-full bg-gray-200 dark:bg-custom-700 overflow-hidden flex-shrink-0">
                    {project.type === 'mobile' && project.video ? (
                      <video 
                        src={project.video} 
                        className="w-full h-full object-contain"
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    ) : (
                      <img 
                        src={project.image} 
                        alt={project.title}
                        className="w-full h-full object-cover"
                      />
                    )}
                  </div>
                  
                  {/* Project Content */}
                  <div className="flex-1 p-4 md:p-6 relative">
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-2 md:mb-3">
                      {project.title}
                    </h3>
                    <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 mb-3 md:mb-4 leading-relaxed">
                      {project.description}
                    </p>
                    <div className="flex flex-wrap gap-1 md:gap-2 mb-4 md:mb-4">
                      {project.technologies.split(' | ').map((tech) => (
                        <span key={tech} className="px-2 md:px-3 py-1 bg-gray-100 dark:bg-custom-700 text-gray-700 dark:text-gray-300 text-xs md:text-sm rounded-full">
                          {tech}
                        </span>
                      ))}
                    </div>
                    <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 md:absolute md:bottom-4 md:right-6">
                      {project.live && (
                        <a
                          href={project.live}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300 text-sm underline"
                        >
                          View Project Live
                        </a>
                      )}
                      {project.github && (
                        <a
                          href={project.github}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 text-sm underline"
                        >
                          View on Github
                        </a>
                      )}
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          )}

          {/* Company Projects */}
          {activeTab === 'company' && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="space-y-8"
            >
              {companyProjects.map((project, index) => (
                <motion.div
                  key={project.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex flex-col md:flex-row gap-4 md:gap-6 relative min-h-[300px] md:h-48"
                >
                  <div className="absolute inset-0 border border-gray-300/20 dark:border-gray-600/20 pointer-events-none"></div>
                  {/* Project Image/Video */}
                  <div className="w-full md:w-64 h-48 md:h-full bg-gray-200 dark:bg-custom-700 overflow-hidden flex-shrink-0">
                    {project.video ? (
                      <video 
                        src={project.video} 
                        className="w-full h-full object-contain"
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    ) : project.image ? (
                      <img 
                        src={project.image} 
                        alt={project.title}
                        className="w-full h-full object-contain"
                      />
                    ) : project.initials ? (
                      <div className="w-full h-full flex items-center justify-center bg-gray-500 text-white">
                        <span className="text-2xl md:text-4xl font-bold">{project.initials}</span>
                      </div>
                    ) : null}
                  </div>
                  
                  {/* Project Content */}
                  <div className="flex-1 p-4 md:p-6 relative">
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-2 md:mb-3">
                      <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white">
                        {project.title}
                      </h3>
                      <span className="text-xs md:text-sm text-primary-600 dark:text-primary-400 font-medium mt-1 sm:mt-0">
                        {project.company}
                      </span>
                    </div>
                    <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 mb-3 md:mb-4 leading-relaxed">
                      {project.description}
                    </p>
                    <div className="flex flex-wrap gap-1 md:gap-2">
                      {project.technologies.map((tech) => (
                        <span key={tech} className="px-2 md:px-3 py-1 bg-gray-100 dark:bg-custom-700 text-gray-700 dark:text-gray-300 text-xs md:text-sm rounded-full">
                          {tech}
                        </span>
                      ))}
                    </div>
                    {project.live && (
                      <div className="mt-3 md:absolute md:bottom-4 md:right-6">
                        <a
                          href={project.live}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300 text-sm underline"
                        >
                          View Project Live
                        </a>
                      </div>
                    )}
                  </div>
                </motion.div>
              ))}
            </motion.div>
          )}
        </div>
      </section>
    </div>
  )
}

export default Projects 